import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import MediaPlaylistModal from '../../../../../containers/Content/Content/MediaPlaylistModal'
import { useSize } from '../../../../utils'
import { Footer, FooterButton, ExclamationIcon, ExclamationCircleIcon, MediaPlaylists } from './MediaItem.style'
import Padding from '../../../../Padding'

function FooterComponent(props) {
    const { t } = useTranslation()
    const { isMobile } = useSize()
    const {
        hasFailedUpload,
        id,
        inPlaylist,
        isApproved,
        isBeingUploaded,
        isNotPushed,
        isRejected,
        isWorking,
        onInspectMedia,
        onRetryUpload,
        playlists: preFilteredPlaylists,
        pushedHasFailed,
        order,
    } = props
    /**
     * On retry upload button click
     * @param {Object} e
     */
    const onRetryUploadClick = (e) => {
        if (typeof e.stopPropagation === 'function') {
            e.stopPropagation()
        }

        onRetryUpload(id)
    }

    /**
     * On approve click
     * @param {Object} e
     */
    const onInspectMediaClick = (e) => {
        if (typeof e.stopPropagation === 'function') {
            e.stopPropagation()
        }

        onInspectMedia(id)
    }

    // Remove the playlist where this media is currently in
    const playlists = preFilteredPlaylists.filter(({ id: pid }) => pid !== inPlaylist)

    const { name: playlistName } = playlists[0] || {}

    const renderPlaylistLabel = () => {
        if (inPlaylist) {
            if (playlists.length === 0) {
                return t('media-in-playlist-alt_0', {
                    count: playlists.length,
                })
            }

            if (playlists.length === 1) {
                return t('media-in-playlist-alt_1', {
                    count: playlists.length,
                    name: playlistName,
                })
            }

            return t('media-in-playlist-alt', {
                count: playlists.length,
                name: playlistName,
            })
        }

        if (playlists.length === 0) {
            return t('media-in-playlist_0', {
                count: playlists.length,
            })
        }

        if (playlists.length === 1) {
            return t('media-in-playlist_1', {
                count: playlists.length,
                name: playlistName,
            })
        }

        return t('media-in-playlist', {
            count: playlists.length,
            name: playlistName,
        })
    }

    const uploadHasFailed = hasFailedUpload && !isWorking
    const isNotApproved = !hasFailedUpload && !isBeingUploaded && !isApproved

    const renderBody = () => {
        if (isWorking) {
            return null
        }

        if (uploadHasFailed) {
            return (
                <FooterButton alert onClick={onRetryUploadClick}>
                    <ExclamationIcon />
                    {t('ErrorUploadingClickToRetry')}
                </FooterButton>
            )
        }

        if (isRejected) {
            return (
                <FooterButton alert onClick={onInspectMediaClick}>
                    <ExclamationCircleIcon />
                    {t('media-rejected')}
                </FooterButton>
            )
        }

        if (pushedHasFailed) {
            return (
                <FooterButton alert onClick={onInspectMediaClick}>
                    <ExclamationCircleIcon />
                    {t('media-failed-push')}
                </FooterButton>
            )
        }

        if (isNotApproved) {
            return (
                <FooterButton onClick={onInspectMediaClick}>
                    <ExclamationCircleIcon />
                    {t('media-approval-pending')}
                </FooterButton>
            )
        }

        if (isNotPushed) {
            return (
                <FooterButton onClick={onInspectMediaClick}>
                    <ExclamationCircleIcon />
                    {t('media-not-pushed')}
                </FooterButton>
            )
        }

        return (
            <MediaPlaylistModal mediaID={id} mediaPlaylists={preFilteredPlaylists} inSelectedPlaylist={!!inPlaylist} order={order}>
                <MediaPlaylists>
                    <Padding left size={isMobile ? 'sm' : 'md'}>
                        {renderPlaylistLabel()}
                    </Padding>
                </MediaPlaylists>
            </MediaPlaylistModal>
        )
    }

    return <Footer>{renderBody()}</Footer>
}

FooterComponent.propTypes = {
    hasFailedUpload: PropTypes.bool,
    id: PropTypes.number,
    inPlaylist: PropTypes.number,
    isApproved: PropTypes.bool,
    isBeingUploaded: PropTypes.bool,
    isNotPushed: PropTypes.bool,
    isRejected: PropTypes.bool,
    isWorking: PropTypes.bool,
    onInspectMedia: PropTypes.func,
    onRetryUpload: PropTypes.func,
    playlists: PropTypes.arrayOf(PropTypes.shape({})),
    pushedHasFailed: PropTypes.bool,
}

FooterComponent.defaultProps = {
    hasFailedUpload: false,
    id: null,
    inPlaylist: null,
    isApproved: false,
    isBeingUploaded: false,
    isNotPushed: false,
    isRejected: false,
    isWorking: false,
    onInspectMedia: () => null,
    onRetryUpload: () => null,
    playlists: [],
    pushedHasFailed: false,
}

export default FooterComponent
